import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
	* {
		box-sizing: border-box;
		outline: 0;
	}

	html,
	body {
		font-family: ${({ theme }) => theme.fontFamily};
		margin: 0;
		padding: 0;
		width: 100%;
		background-color: ${({ theme }) => theme.colors.black};
		color: ${({ theme }) => theme.colors.text};
		font-family:${({ theme }) => theme.fonts.text}, sans-serif;
	}

	#___gatsby, #gatsby-focus-wrapper {
		width: 100%;
		background-color: ${({ theme }) => theme.colors.background};
	}

	a {
		text-decoration: none;
		color: ${({ theme }) => theme.colors.primary};
	}

	${
    '' /* p {
	    font-variation-settings: 'wght' 450;
	    font-size: 1rem;
	    line-height: 1.75rem;
	}

	h1 {
		margin-top: 0;
		font-size: 2rem;
		line-height: 2.5rem;
		margin-bottom: 2rem;
		font-variation-settings: 'wght' 800;
		color: ${({ theme }) => theme.colors.text};
	}
	
	h2 {
		margin-top: 0;
		font-size: 1.75rem;
		line-height: 2.25rem;
		font-variation-settings: 'wght' 700;
		margin-bottom: 1.75rem;
		color: ${({ theme }) => theme.colors.text};
	}

	h3 {
		margin-top: 0;
		font-size: 1.5rem;
		line-height: 2rem;
		font-variation-settings: 'wght' 600;
		margin-bottom: 1.5rem;
		color: ${({ theme }) => theme.colors.text};
	}

	h4 {
		margin-top: 0;
		font-size: 1.25rem;
		line-height: 1.75rem;
		font-variation-settings: 'wght' 600;
		margin-bottom: 1.25rem;
		color: ${({ theme }) => theme.colors.text};
	}
	
	h5, h6 {
		margin-top: 0;
		font-size: 1rem;
		line-height: 1.5rem;
		font-variation-settings: 'wght' 600;
		margin-bottom: 1rem;
		color: ${({ theme }) => theme.colors.text};
	}

	h6 {
		opacity: 0.6;
	}
	
	
	
	code {
	    background-color: ${({theme}) => theme.colors.primary}15 !important;
        color: ${({theme}) => theme.colors.primary};
        white-space: pre-wrap;
        line-height: normal;
        font-size: 80%;
        font-family: "JetBrains Mono", SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;
        padding: 0.25rem .4rem;
        margin: 0 -0.125rem;
        border-radius: .5rem;
    }

	blockquote {
	    position: relative;
		background-color: ${({ theme }) => styleUtils.colors.fade(theme.colors.primary, .04)};
		padding: 1.5rem;
		margin: 0;
		overflow: hidden;
		border-radius: 0 ${({ theme }) => theme.borderRadius * 1.5}rem ${({ theme }) => theme.borderRadius * 1.5}rem 0;
		
		&:before {
		    position: absolute;
		    content: "";
		    width: .25rem;
		    left: 0;
		    top: 0;
		    bottom: 0;
			border-radius: 1rem;
		    background-color: ${({ theme }) => theme.colors.primary};
		}
		
		& p {
			margin: 0;
		}
	} */
  }

	code {
		display: inline-flex;
		background-color: ${({ theme }) => theme.colors.textA[5]};
		border: 1px solid ${({ theme }) => theme.colors.border};
		color: ${({ theme }) => theme.colors.primary};
        font-size: 75%;
		font-family: ${({ theme }) => theme.fonts.code};
		font-weight: 400 !important; 
        white-space: pre-wrap;
        line-height: normal;
        padding: 0.25rem .4rem;
        margin: 0 0.125rem;
        border-radius: ${({ theme }) => theme.radii[1]};
    }

	pre > code {
		display: inherit;
		background: none;
		border: none;
		font-size: 100%;
		padding: 0;
		margin: 0;
		line-height: 1.25rem;
	}

	ul, ol {
		margin: 0;
		padding-left: 2rem;
		
		li + li {
		    margin-top: .5rem;
		}
	}
	
	img {
	    max-width: 100%;
	    width: 100%;
	}
`
